import ShiftCollapse from './ShiftCollapse'

export default ShiftCollapse